interface AddMineButtonProps {
    onClick: (addMode: boolean) => void;
    addMode: boolean;
};

function AddMineButton({ onClick, addMode }: AddMineButtonProps) {
  return (
        <button 
            className={`floating-btn add-btn ${addMode ? 'active' : ''}`}
            onClick={() => onClick(!addMode)}
            data-tooltip={addMode ? "Zrušit přidávání" : "Přidat prvek"}
        >
            <svg viewBox="0 0 24 24" fill="currentColor">
                {addMode ? (
                <path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"/>
                ) : (
                <path d="M19 13h-6v6h-2v-6H5v-2h6V5h2v6h6v2z"/>
                )}
            </svg>
        </button>
  );
}

export default AddMineButton;